import type { SampleTemplate } from './samplePreviewTypes';

export const SAMPLE_TEMPLATES: SampleTemplate[] = [
  {
    id: 'pdp-01',
    title: 'PAISLEY SATIN MIDI SKIRT',
    thumbnailImage: '/commerce/static/intro/pdp/pdp_1_1.webp',
    previewImage: '/commerce/static/intro/pdp/pdp_1_1.webp',
    fullDetailImage: '/commerce/static/intro/pdp/pdp_1_2.webp',
    fullDetailImageWidth: 1000,
    fullDetailImageHeight: 12175,
    accentType: 'image',
    tintLabel: 'Main',
  },
  {
    id: 'pdp-02',
    title: 'NEUTRAL EDIT',
    thumbnailImage: '/commerce/static/intro/pdp/pdp_2_1.webp',
    previewImage: '/commerce/static/intro/pdp/pdp_2_1.webp',
    fullDetailImage: '/commerce/static/intro/pdp/pdp_2_2.webp',
    fullDetailImageWidth: 1000,
    fullDetailImageHeight: 15331,
    accentType: 'gray',
    tintLabel: 'Gray',
  },
  {
    id: 'pdp-03',
    title: 'SKY POP',
    thumbnailImage: '/commerce/static/intro/pdp/pdp_3_1.webp',
    previewImage: '/commerce/static/intro/pdp/pdp_3_1.webp',
    fullDetailImage: '/commerce/static/intro/pdp/pdp_3_2.webp',
    fullDetailImageWidth: 1000,
    fullDetailImageHeight: 15723,
    accentType: 'sky',
    tintLabel: 'Sky',
  },
  {
    id: 'pdp-04',
    title: 'SOFT ROSE',
    thumbnailImage: '/commerce/static/intro/pdp/pdp_4_1.webp',
    previewImage: '/commerce/static/intro/pdp/pdp_4_1.webp',
    fullDetailImage: '/commerce/static/intro/pdp/pdp_4_2.webp',
    fullDetailImageWidth: 1000,
    fullDetailImageHeight: 12777,
    accentType: 'rose',
    tintLabel: 'Rose',
  },
  {
    id: 'pdp-05',
    title: 'NOIR EDIT',
    thumbnailImage: '/commerce/static/intro/pdp/pdp_5_1.webp',
    previewImage: '/commerce/static/intro/pdp/pdp_5_1.webp',
    fullDetailImage: '/commerce/static/intro/pdp/pdp_5_2.webp',
    fullDetailImageWidth: 1000,
    fullDetailImageHeight: 9888,
    accentType: 'charcoal',
    tintLabel: 'Noir',
  },
  {
    id: 'pdp-06',
    title: 'METALLIC RUSH',
    thumbnailImage: '/commerce/static/intro/pdp/pdp_6_1.webp',
    previewImage: '/commerce/static/intro/pdp/pdp_6_1.webp',
    fullDetailImage: '/commerce/static/intro/pdp/pdp_6_2.webp',
    fullDetailImageWidth: 1000,
    fullDetailImageHeight: 12081,
    accentType: 'image',
    tintLabel: 'Metallic',
  },
  {
    id: 'pdp-07',
    title: 'URBAN MONO',
    thumbnailImage: '/commerce/static/intro/pdp/pdp_7_1.webp',
    previewImage: '/commerce/static/intro/pdp/pdp_7_1.webp',
    fullDetailImage: '/commerce/static/intro/pdp/pdp_7_2.webp',
    fullDetailImageWidth: 1000,
    fullDetailImageHeight: 14268,
    accentType: 'gray',
    tintLabel: 'Urban',
  },
  {
    id: 'pdp-08',
    title: 'AZURE WAVE',
    thumbnailImage: '/commerce/static/intro/pdp/pdp_8_1.webp',
    previewImage: '/commerce/static/intro/pdp/pdp_8_1.webp',
    fullDetailImage: '/commerce/static/intro/pdp/pdp_8_2.webp',
    fullDetailImageWidth: 1000,
    fullDetailImageHeight: 8188,
    accentType: 'sky',
    tintLabel: 'Azure',
  },
  {
    id: 'pdp-09',
    title: 'BLUSH STUDIO',
    thumbnailImage: '/commerce/static/intro/pdp/pdp_9_1.webp',
    previewImage: '/commerce/static/intro/pdp/pdp_9_1.webp',
    fullDetailImage: '/commerce/static/intro/pdp/pdp_9_2.webp',
    fullDetailImageWidth: 1000,
    fullDetailImageHeight: 7322,
    accentType: 'rose',
    tintLabel: 'Blush',
  },
  {
    id: 'pdp-10',
    title: 'MIDNIGHT MUSE',
    thumbnailImage: '/commerce/static/intro/pdp/pdp_10_1.webp',
    previewImage: '/commerce/static/intro/pdp/pdp_10_1.webp',
    fullDetailImage: '/commerce/static/intro/pdp/pdp_10_2.webp',
    fullDetailImageWidth: 1000,
    fullDetailImageHeight: 8197,
    accentType: 'charcoal',
    tintLabel: 'Midnight',
  },
];
